<template>
  <div>
    <DataTable
      ref="DataTable"
      :data-model="'orders.payments'"
      :items="items"
      :loading="loading"
      :permission-name="'Payments'"
      :exclude-fields="['id', 'orderId']"
      :items-per-page="10"
      :allow-create="false"
      :allow-delete="false"
      :allow-edit="false"
      :allow-view="false"
      :display-name-plural="$t('entities.Payment.Plural')"
      :display-name-singular="$t('entities.Payment.Singular')">
      <template #cell(complete)="row">
        {{ $t('common.'+row.item.complete) }}
      </template>
      <template #cell(amount)="row">
        {{ row.item.amount + ' Kč' }}
      </template>
      <template #cell(type)="row">
        {{ $t('payment.type.' + row.item.type) }}
      </template>
      <template #extraActions="row">
        <el-tooltip :content="$t('common.View')"
                    :enterable="false"
                    placement="top">
          <b-button class="viewBtn mr-1"
                    @click="view(row.item.orderId)">
            <font-awesome-icon class="fa-xs"
                               icon="search" />
          </b-button>
        </el-tooltip>
        <el-tooltip
          :content="$t('common.CompletePayment')"
          :enterable="false"
          placement="top"
          v-if="!row.item.complete && $auth.check(
            'Permissions.AdminPanel.Payments.Edit'
          )">
          <b-button class="mx-1"
                    variant="success"
                    @click="toComplete = row.item; $refs.completeModal.show();">
            <font-awesome-icon class="fa-xs"
                               icon="check" />
          </b-button>
        </el-tooltip>
        <el-tooltip
          :content="$t('common.ConvertToCash')"
          :enterable="false"
          placement="top"
          v-if="!row.item.complete && $auth.check(
            'Permissions.AdminPanel.Payments.Edit'
          )">
          <b-button class="downloadBtn mx-1"
                    @click="toConvert = row.item; $refs.convertModal.show();">
            <font-awesome-icon class="fa-md"
                               icon="euro-sign" />
          </b-button>
        </el-tooltip>
      </template>
      <template #extraTableActions>
        <b-button
          class="ml-2"
          variant="primary"
          @click="exportPayments()">
          {{ $t('common.ExportPayments') }}
        </b-button>
      </template>
    </DataTable>
    <b-modal id="modal-center"
             ref="completeModal"
             centered
             :static="true">
      <template #modal-header>
        <div class="d-flex justify-content-center w-100 text-center">
          <h3>
            {{ $t('common.CompletePayment') }}
          </h3>
        </div>
      </template>
      <p class="my-4 text-center">
        {{ $t('common.ConfirmCompletePayment') }}
      </p>
      <template #modal-footer="{ cancel, ok }">
        <b-button
          variant="secondary"
          @click="toComplete = {}; $refs.completeModal.hide();">
          {{ $t('common.Cancel') }}
        </b-button>
        <b-button
          variant="success"
          @click="completePayment();">
          {{ $t('common.CompletePayment') }}
        </b-button>
      </template>
    </b-modal>
    <b-modal id="modal-center"
             ref="convertModal"
             centered
             :static="true">
      <template #modal-header>
        <div class="d-flex justify-content-center w-100 text-center">
          <h3>
            {{ $t('common.ConvertPayment') }}
          </h3>
        </div>
      </template>
      <p class="my-4 text-center">
        {{ $t('common.ConfirmConvertPayment') }}
      </p>
      <template #modal-footer="{ cancel, ok }">
        <b-button
          variant="secondary"
          @click="toConvert = {}; $refs.convertModal.hide();">
          {{ $t('common.Cancel') }}
        </b-button>
        <b-button
          variant="success"
          @click="convertPayment();">
          {{ $t('common.ConvertPayment') }}
        </b-button>
      </template>
    </b-modal>
    <b-modal id="modal-center"
             ref="downloadModal"
             centered
             :ok-disabled="true"
             :static="true">
      <template #modal-header>
        <div class="d-flex justify-content-center w-100 text-center">
          <h3>
            {{ $t('common.Downloading') }}
          </h3>
        </div>
      </template>
      <p class="my-4 text-center">
        {{ $t('common.Generating') }}
      </p>
      <div id="nprogressDownload"
           style="height:25px" />
      <template #modal-footer="{ cancel, ok }">
        <b-button
          variant="danger"
          @click="cancelDownload(); $refs.downloadModal.hide()">
          {{ $t('common.Cancel') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import DataTable from '@components/admin/DataTable';
import NProgress from 'nprogress/nprogress';
import { downloadBlob } from '@utils/downloadBlob';

export default {
  name: 'ViewPayments',
  components: {
    DataTable
  },
  data() {
    return {
      toComplete: {},
      toConvert: {},
      source: null,
      items: [],
      loading: true
    };
  },
  mounted() {
    this.source = this.axios.CancelToken.source();
  },
  created() {
    this.getPayments();
  },
  methods: {
    view(id) {
      this.$router.push({ name: 'admin.orders.viewdetail', params: { id } });
    },
    getPayments() {
      this.axios.get('/admin/payments')
        .then((res) => {
          if (res.status === 200 && res.data.result.length > 0) {
            this.items = res.data.result;
          } else {
            this.items = [];
          }
          this.loading = false;
        }).catch((err) => Promise.reject(err)).finally(() => {
          this.$refs.DataTable.finishSpinner();
        });
    },
    cancelDownload() {
      this.source.cancel();
      this.source = this.axios.CancelToken.source();
    },
    convertPayment() {
      const url = this.toConvert.type === 1 ? '/admin/payments/changebanktransfertocashpayment' : '/admin/payments/changecardtocashpayment';
      return this.axios.post(url, {
        Id: this.toConvert.id
      }).then((res) => {
        if (res.status === 204) {
          this.$root.$bvToast.toast(this.$t('common.SuccessfullyConverted'), {
            title: this.$t('CreateMoneyVoucher.SuccessToast.Title'),
            variant: 'success',
            toaster: 'b-toaster-top-right'
          });
        }
        this.toConvert = {};
        this.getPayments();
        this.$refs.convertModal.hide();
      }).catch(() => {
        this.$root.$bvToast.toast(this.$t('common.CouldNotConvert'), {
          title: this.$t('CreateMoneyVoucher.FailToast.Title'),
          variant: 'danger',
          toaster: 'b-toaster-top-right'
        });
        this.toConvert = {};
        this.$refs.convertModal.hide();
      });
    },
    completePayment() {
      const url = this.toComplete.type === 1 ? '/admin/payments/confirmbanktransferpayment' : '/admin/payments/confirmcardpayment';
      return this.axios.post(url, {
        Id: this.toComplete.id
      }).then((res) => {
        if (res.status === 204) {
          this.$root.$bvToast.toast(this.$t('common.SuccessfullyCompleted'), {
            title: this.$t('CreateMoneyVoucher.SuccessToast.Title'),
            variant: 'success',
            toaster: 'b-toaster-top-right'
          });
        }
        this.toComplete = {};
        this.getPayments();
        this.$refs.completeModal.hide();
      }).catch(() => {
        this.$root.$bvToast.toast(this.$t('common.CouldNotComplete'), {
          title: this.$t('CreateMoneyVoucher.FailToast.Title'),
          variant: 'danger',
          toaster: 'b-toaster-top-right'
        });
        this.toComplete = {};
        this.$refs.completeModal.hide();
      });
    },
    exportPayments() {
      this.$refs.downloadModal.show();
      NProgress.configure({ parent: '#nprogressDownload' });
      NProgress.start();
      this.axios.get('admin/payments/exportallpayments', {
        responseType: 'arraybuffer',
        cancelToken: this.source.token
      }).then((response) => {
        const today = new Date();
        downloadBlob(
          response.data,
          `Export plateb ${today.toLocaleDateString('en-US')}.xlsx`,
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        );
        this.$refs.downloadModal.hide();
      }).catch((thrown) => {
        if (this.axios.isCancel(thrown)) {
          this.$root.$bvToast.toast(this.$t('common.DownloadCancel'), {
            title: this.$t('common.Cancelled'),
            variant: 'danger',
            toaster: 'b-toaster-top-right'
          });
          this.$refs.downloadModal.hide();
        }
      })
        .finally(() => {
          NProgress.configure({ parent: 'body' });
          NProgress.done();
        });
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@colors';
.downloadBtn {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  background-color: #c95328;
  color: $text-on-secondary;
  border: none;
  &:hover {
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
    background-color: darken($secondary-variant-color, 10%);
    color: $text-on-secondary;
  }
}

.viewBtn {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  background-color: $secondary-color;
  color: $text-on-secondary;
  border: none;
  &:hover {
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
    background-color: darken($secondary-color, 10%);
    color: $text-on-secondary;
  }
}
</style>
